import { STORAGE_PREFIX } from '@root/shared'

export const USERNAME_KEY = `${STORAGE_PREFIX}/v1/username`
